import type { ReactNode } from "react";

/**
 * THE DESK TOOLS' GLYPHS (2026-10-31, Andre): a small printed symbol before
 * each word in the desk's heading — a stack beside "tidy.", an arrow turned
 * back on itself beside "undo.", a chevron after "arrange by." — in the
 * bin's own line: sixteen-unit strokes, monochrome, the button's ink, a
 * shade heavier than the bin's (1.4 to its 1.2) because they are drawn
 * smaller and should weigh what the word does. Decoration for the eye and
 * nothing for the record: `aria-hidden`, no title, no text, so each button
 * still reads as its one word.
 */
const TOOL_GLYPHS = {
  /** Three sheets seen edge-on, one upon another. */
  tidy: "M8 2.5l6 3-6 3-6-3z M2 8.5l6 3 6-3 M2 11.5l6 3 6-3",
  /** An arrow that comes back over its own path. */
  undo: "M2.6 5v3.6h3.6 M13.4 11a5.4 5.4 0 0 0-5.4-5.4 5.4 5.4 0 0 0-3.6 1.4L2.6 8.6",
  /** A chevron pointing down: there is a list under this word. */
  menu: "M4 6.5l4 4 4-4",
} as const;
export type ToolGlyphName = keyof typeof TOOL_GLYPHS;

export function ToolGlyph({ of }: { of: ToolGlyphName }): ReactNode {
  return (
    <svg className="pcs-tool-glyph" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={TOOL_GLYPHS[of]} />
    </svg>
  );
}
